import { render, staticRenderFns } from "./IssueEditor.vue?vue&type=template&id=afd5467c&"
import script from "./IssueEditor.vue?vue&type=script&lang=ts&"
export * from "./IssueEditor.vue?vue&type=script&lang=ts&"
import style0 from "./IssueEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd5467c')) {
      api.createRecord('afd5467c', component.options)
    } else {
      api.reload('afd5467c', component.options)
    }
    module.hot.accept("./IssueEditor.vue?vue&type=template&id=afd5467c&", function () {
      api.rerender('afd5467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/issues/IssueEditor.vue"
export default component.exports